// extracted by mini-css-extract-plugin
var _1 = "sW8Yf";
var _2 = "u15MV";
var _3 = "F29Qk";
var _4 = "_T9eW";
var _5 = "Wgn7X";
var _6 = "Q_xna";
var _7 = "ZXgxI";
var _8 = "GOc_c";
var _9 = "oNt4c";
var _a = "WvVvp";
export { _1 as "align-end", _2 as "align-start", _3 as "base", _4 as "header", _5 as "highlight", _6 as "isExpanded", _7 as "resizer", _8 as "section", _9 as "title", _a as "toggle" }
